// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__TsFIa","wrapper-table":"Table_wrapper-table__Md2es"};